window.cardBackService = {
  get() {
    return axios.get('/api/backings/get.php');
  },

  getShopItems(twitchId) {
    const params = twitchId ? `?store=1&twitch_id=${twitchId}` : '?store=1';
    return axios.get(`/api/backings/get.php${params}`);
  },

  save(data) {
    return axios.post('/api/backings/save.php', data);
  },

  purchaseShopItem(backingId) {
    return axios.post('/api/backings/buy.php', { backing_id: backingId });
  },

  equip(backingId) {
    return axios.post('/api/backings/equip.php', { backing_id: backingId });
  },

  getTeamBacking(teamId) {
    return axios.get(`/api/user/team/equip-backing.php?team_id=${teamId}`);
  },

  equipTeamBacking(teamId, backingId) {
    return axios.post('/api/user/team/equip-backing.php', { team_id: teamId, backing_id: backingId });
  },

};
